import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import isEmpty from "lodash/isEmpty";
import _ from "lodash";
import {
  Container,
  Button,
  InputGroup,
  InputGroupAddon,
  Input,
  InputGroupText,
  Row,
  Col,
  Badge
} from "reactstrap";

import { connect } from "react-redux";
import {
  getPrescriptions,
  postPrescriptions,
  getPrescriptionHistory,
  getPrescriptionByNumber,
  presc_modal_view
} from "../../actions/mqttAction";
import PropTypes from "prop-types";

import { TablePagination } from "react-pagination-table";

class ReviewComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 1,
      searchList: [],
      search: false,
      searchTerm: ""
    };
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  UNSAFE_componentWillMount() {
    //console.log("===========Props Review============"+JSON.stringify(this.props.pendingPrescription));
    this.setState({
      searchList: this.props.pendingPrescription
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.pendingPrescription) {
      this.setState({
        searchList: nextProps.pendingPrescription
      });
    }
  }

  handlePageChange(pageNumber) {
    console.log(`active page is ${pageNumber}`);
    this.setState({ activePage: pageNumber });
  }
  onSearch = e => {
    e.preventDefault();
    this.setState({ search: true });
    this.setState({ searchTerm: e.target.value.toLowerCase() }, () => {
      let filterPending;
      filterPending = _.filter(
        this.props.pendingPrescription,
        pending =>
          pending.patientInfo.firstName
            .toLowerCase()
            .includes(this.state.searchTerm) ||
          pending.patientInfo.lastName
            .toLowerCase()
            .includes(this.state.searchTerm) ||
          pending.rxInfo.prescriptionNumber
            .toLowerCase()
            .includes(this.state.searchTerm)
      );
      this.setState({ searchList: filterPending });
    });
  };
  renderButton(pharmacist_info, isEditing) {
    if (isEditing) {
      var button = (
        <div>
          <div>
            <i className="fas fa-user"></i>
          </div>
          <div>{pharmacist_info.name}</div>
        </div>
      );
      return button;
    } else {
      var button = <span></span>;
      return button;
    }
  }
  openModalView(pendingPrescription) {
    let isView = true;
    let prescription = pendingPrescription;
    let patientId = pendingPrescription.patientInfo.patientId;
    let prescriptionNumber = pendingPrescription.rxInfo.prescriptionNumber;
    this.props.presc_modal_view(
      isView,
      prescription,
      patientId,
      prescriptionNumber
    );
  }

  renderPrescNamee(isEditing) {
    let badge;
    if (isEditing) {
      badge = (
        <Badge color="warning" pill className="ml-1">
          in Editing
        </Badge>
      );
    }
    return badge;
  }

  renderPatientName(isWaiting) {
    let badge;
    if (isWaiting) {
      badge = (
        <Badge color="danger" pill className="ml-1">
          Patient Waiting
        </Badge>
      );
    }
    return badge;
  }

  render() {
    const headers = [
      "Edit",
      "Name",
      "Prescription",
      "Branch",
      "Tab",
      "ProcessedAt",
      "Actions"
    ];
    let pendingArray = [];
    this.state.searchList.sort(function (a, b) {
      return b.patientInfo.patientAdditionalInfo.patientWaiting - a.patientInfo.patientAdditionalInfo.patientWaiting || new Date(b.updateAt) - new Date(a.updateAt);
    });
    this.state.searchList.map(pending => {
      let date = String(pending.updateAt).split(" ")[0];
      let time = String(pending.updateAt).split(" ")[1];
      pendingArray.push({
        edit: (
          <span>
            <Link to='#' onClick={() => this.openModalView(pending)}>
              <i
                className="far fa-edit"
                onClick={() => this.openModalView(pending)}
              ></i>
            </Link>
          </span>
        ),
        name: (
          <Link to='#' onClick={() => this.openModalView(pending)}>
            <span className="text-capitalize">
              <strong>
                {pending.patientInfo.firstName.toUpperCase()} {pending.patientInfo.lastName.toUpperCase()}
              </strong>
              {this.renderPatientName(pending.patientInfo.patientAdditionalInfo.patientWaiting)}
              <div className="text-info">{pending.patientInfo.dateOfBirth}</div>
            </span>
          </Link>
        ),
        prescription: (
          <Link to='#' onClick={() => this.openModalView(pending)}>
            <span>
              <strong>{pending.rxInfo.prescriptionNumber}</strong>
              {this.renderPrescNamee(pending.isEditing)}
              <div className="text-info rx-name">{pending.rxInfo.rxName}</div>
            </span>
          </Link>
        ),
        branch: (
          <div>{isEmpty(pending.branchName) ? "N/A" : pending.branchName}</div>
        ),
        tab: <span>{pending.rxInfo.rxType}</span>,
        date: (
          <span>
            {date}
            <br></br>
            <span className="text-info">{time}</span>
          </span>
        ),
        // patientWaiting: (
        //   <span>
        //     <Input
        //       id="patientWaiting"
        //       name="patientWaiting"
        //       type="checkbox"
        //       onChange={this.props.checked}
        //     />
        //     <label>PatientWaiting</label>
        //   </span>
        // )
      });
    });

    const pending = (
      <TablePagination
        // headers={headers}
        data={pendingArray}
        columns="edit.name.prescription.branch.tab.date"
        perPageItemCount={6}
        totalCount={this.props.pendingPrescription.length}
        arrayOption={[[]]}
        className={
          "text-center table table-borderless table-striped font-style"
        }
        paginationClassName={"react-paginate"}
      />
    );

    // return <div className="py-2">{pending}</div>;
    return (
      <div>

        <div className="py-2">
          <Row className=" pl-2">
            <Col>
              <InputGroup className="mb-3">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fas fa-search" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  onChange={this.onSearch.bind(this)}
                />
              </InputGroup>
            </Col>
          </Row>

          {pending}
        </div>
      </div>
    );
  }
}

ReviewComponent.propTypes = {
  getPrescriptionHistory: PropTypes.func.isRequired,
  getPrescriptions: PropTypes.func.isRequired,
  getPrescriptionByNumber: PropTypes.func.isRequired,
  postPrescriptions: PropTypes.func.isRequired,
  mqtt: PropTypes.object.isRequired,

  presc_modal_view: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  mqtt: state.mqtt,
  auth: state.auth
});

export default connect(mapStateToProps, {
  postPrescriptions,
  getPrescriptionHistory,
  getPrescriptionByNumber,
  getPrescriptions,
  mqtt: PropTypes.object.isRequired,
  presc_modal_view
})(withRouter(ReviewComponent));
